import { render, staticRenderFns } from "./tenant_config_favorites_defaults.vue?vue&type=template&id=70353337&scoped=true&"
import script from "./tenant_config_favorites_defaults.vue?vue&type=script&lang=js&"
export * from "./tenant_config_favorites_defaults.vue?vue&type=script&lang=js&"
import style0 from "./tenant_config_favorites_defaults.vue?vue&type=style&index=0&id=70353337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70353337",
  null
  
)

export default component.exports